import {ReactNode} from 'react';
import NOFilter, {Props as NOProps} from '../no-filter';
import RosterSelection from '../filter-types/roster-selection';
import {Data_1} from '@carbon/icons-react';

type FilterContainerProps = {
    showRosterSelection?: boolean;
    filterConfiguration: Array<NOProps>;
    children?: ReactNode;
    horizontal?: boolean;
};

const FilterContainer = ({
    showRosterSelection = false,
    filterConfiguration,
    children,
    horizontal = false,
}: FilterContainerProps) => {
    if (horizontal) {
        return (
            <div className='flex flex-row items-center justify-between gap-8 w-full'>
                {filterConfiguration.map((filter, index) => (
                    <div key={`filter-${index}`} className='flex-1'>
                        <NOFilter searchable {...filter} />
                    </div>
                ))}
                {children}
            </div>
        );
    }

    return (
        <div className='geography-filters bg-white py-4 px-6 w-64 min-h-[calc(100%)] flex flex-col'>
            <div className='flex flex-row items-center justify-between'>
                <h1 className='text-lg font-semibold'>Filters</h1>
                <Data_1 />
            </div>
            <hr />
            <div className='flex-grow mt-3'>
                {showRosterSelection && (
                    <RosterSelection maxSelectableRosters={2} addCurrentRosterToSelection={true} />
                )}

                {filterConfiguration.map((f, i) => (
                    <NOFilter searchable key={i} {...f} />
                ))}

                {children}
            </div>
        </div>
    );
};

export default FilterContainer;
